module.exports = __webpack_public_path__ + "img/mianyi.7dd1609e.png";